import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

export const rolePermissionsSearchAPI = function (data) {
    const url = `${config.baseUrl}permissions/search`;
    return postRequest({
        url,
        data,
    });
};

export const rolePermissionsCreateAPI = function (data) {
    const url = `${config.baseUrl}permissions/upsert`;
    return postRequest({
        url,
        data,
    });
};

export const rolePermissionsUpdateAPI = function ({
    rolePermissionsId,
    data,
}) {
    const url = `${config.baseUrl}permissions/${rolePermissionsId}`;
    return putRequest({
        url,
        data,
    });
};
